import React from 'react';

import WebdesignHero from '../components/WebdesignHero/WebdesignHero';
import WebsitePackages from '../components/WebsitePackages/WebsitePackages';
import WhatToExpect from '../components/WhatToExpect/WhatToExpect';
import WebsiteProcess from '../components/WebsiteProcess/WebsiteProcess';
import WebsiteTestimonials from '../components/WebsiteTestimonials/WebsiteTestimonials';
import WebsitePortfolio from '../components/WebsitePortfolio/WebsitePortfolio';
import ModernWhyChooseUs from '../components/ModernWhyChooseUs/ModernWhyChooseUs';

const WebdesignPage = () => {

  return (
    <>
      <WebdesignHero />
      <WebsitePackages />
      <WhatToExpect />
      <WebsiteProcess />
      {/* <WebsiteTestimonials /> */}
      <WebsitePortfolio />
      <ModernWhyChooseUs />
    </>
  );
};

export default WebdesignPage; 